export default __webpack_public_path__ + "static/2283-b5687ced06551d9e98a98b547ec79e0c.gif";